// src/components/common/Toast.js
import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

const Toast = ({ id, type = 'info', title, message, onClose, duration = 5000 }) => {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                onClose(id);
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [id, duration, onClose]);

    const styles = {
        success: {
            bg: 'bg-green-50 dark:bg-green-900/20',
            border: 'border-green-400 dark:border-green-500',
            text: 'text-green-800 dark:text-green-200',
            icon: CheckCircle,
            iconColor: 'text-green-500 dark:text-green-400'
        },
        error: {
            bg: 'bg-red-50 dark:bg-red-900/20',
            border: 'border-red-400 dark:border-red-500',
            text: 'text-red-800 dark:text-red-200',
            icon: XCircle,
            iconColor: 'text-red-500 dark:text-red-400'
        },
        warning: {
            bg: 'bg-yellow-50 dark:bg-yellow-900/20',
            border: 'border-yellow-400 dark:border-yellow-500',
            text: 'text-yellow-800 dark:text-yellow-200',
            icon: AlertCircle,
            iconColor: 'text-yellow-500 dark:text-yellow-400'
        },
        info: {
            bg: 'bg-blue-50 dark:bg-blue-900/20',
            border: 'border-blue-400 dark:border-blue-500',
            text: 'text-blue-800 dark:text-blue-200',
            icon: Info,
            iconColor: 'text-blue-500 dark:text-blue-400'
        }
    };

    const style = styles[type] || styles.info;
    const Icon = style.icon;

    return (
        <div
            className={`${style.bg} border-l-4 ${style.border} p-4 rounded-lg shadow-lg mb-4 animate-slide-in-right max-w-md`}
            role="alert"
        >
            <div className="flex items-start">
                <Icon className={`${style.iconColor} h-5 w-5 mr-3 flex-shrink-0 mt-0.5`} />
                <div className="flex-1 mr-2">
                    {title && (
                        <h3 className={`font-semibold ${style.text} mb-1`}>
                            {title}
                        </h3>
                    )}
                    <p className={`text-sm ${style.text}`}>
                        {message}
                    </p>
                </div>
                <button
                    onClick={() => onClose(id)}
                    className={`${style.iconColor} hover:opacity-70 flex-shrink-0`}
                    aria-label="Close"
                >
                    <X className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};

export default Toast;
